// Definitions

(function() {

  if (typeof window.SITE === "undefined") {
    window.SITE = {};
  }

  SITE.mainMenuDropDown = function() {
    $('#nav-main > ul > li.menu-item-has-children').hover(function() {
      if (!$(this).hasClass('open')) {
        $(this).addClass('open');
      }
    }, function() {
      $(this).removeClass('open');
    });
  }

  SITE.mainMenuScroll = function() {
    $(window).scroll(function() {
      var offset = $(window).scrollTop();

      if (offset > 0) {
        $('#header').addClass('scrolling');
      }
      else {
        $('#header').removeClass('scrolling');
      }
    });
  }

  SITE.enableSubMenu = function() {
    $sideBarMenu = $('#nav-sub-menu-sidebar');

    if ($sideBarMenu.length) {
      $parentMenuActive = $sideBarMenu.find('ul li.menu-item-has-children.current-menu-ancestor');

      if ($parentMenuActive.length) {
        $parentMenuActive.find('ul').show();
        $parentMenuActive.removeClass('open');
      }

      $parentPage = $sideBarMenu.find('.current-menu-item.menu-item-has-children');
      console.log($parentPage)
      if ($parentPage.length) {
        console.log($parentPage.find('ul'));
        $parentPage.find('.triangle');
        $parentPage.toggleClass('open');
        $parentPage.find('ul').css('display','block')
      }

      $sideBarMenu.find('.triangle').click(function(e) {
        $(this).parent().find('ul').slideToggle();
        $(this).parent().toggleClass('open');
      });
    }

  }

  SITE.focusSearch = function() {
    var searchbox = document.querySelector('#trigger-search-wrapper');
    searchbox.firstElementChild.addEventListener("click", function() {
      var input = document.querySelector('.search-field');
      console.log(input)
      input.tabIndex = "0";
      input.focus();
      input.select();
    })
  }

})();


// Invocations

$(function () {
  // Make SVG maps work in IE.
  svg4everybody();

  SITE.mainMenuDropDown();

  SITE.mainMenuScroll();

  SITE.enableSubMenu();

  SITE.focusSearch();

  var content = document.querySelector('.content .page__body.wysiwyg');
  if (content && content.innerHTML == '') {
    content.parentElement.parentElement.parentElement.style.minHeight = 0
  }

});
